export default "__VITE_ASSET__BtVtX7l3__"